import { fromEvent, interval, animationFrameScheduler } from 'rxjs';
import { map, withLatestFrom, distinctUntilChanged } from 'rxjs/operators';

import { tiltSpeed, initTransform } from './constants'
import { createRoomMovement } from './roomHelpers'

export default () => {
	let win = {
		width: window.innerWidth,
		height: window.innerHeight
	}
	
	const mapToMousePos = (event: MouseEvent) => {
		const noMousePos = {
			x: null,
			y: null
		}
	
		if (!event) { return noMousePos }
	
		if (event.pageX || event.pageY) {
			return {
				x: event.pageX,
				y: event.pageY
			}
		}
	
		return noMousePos
	}
	
	const mapToRotationValues = ({ x, y }) => {
		return {
			rotX: x !== null ? initTransform.rotateX - (2 * tiltSpeed.rotateX / win.height * y - tiltSpeed.rotateX) : 0,
			rotY: y !== null ? initTransform.rotateY - (2 * tiltSpeed.rotateY / win.width * x - tiltSpeed.rotateY) : 0
		}
	}
	
	const mapToTransform = ({ rotX, rotY }) => {
		return createRoomMovement({ rotateX: rotX, rotateY: rotY })
	}
	
	// interface Cord { x: number, y:number }
	// const isSame = (prev:Cord, curr:Cord) => {
	// 	return prev.x === curr.x || prev.y === curr.y
	// }
	
	const animationFrame$ = interval(0, animationFrameScheduler)

	const move$ = fromEvent(document.documentElement, 'mousemove')
	
	const smoothMove$ = animationFrame$.pipe(
		withLatestFrom(move$, (frame, move) => move),
		map(mapToMousePos),
		// distinctUntilChanged(isSame),
		map(mapToRotationValues),
		map(mapToTransform)
	)

	return {
		smoothMove$
	}
}